import React, { useState } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";

const DemoQuestions = () => {
    const [isActivated, setActivated] = useState(true);
    const [fullwidthwrapper, setFullWidthWrapper] = useState("");

    const handleToggle = () => {
        setActivated(!isActivated);
        setFullWidthWrapper(isActivated ? "fullwrapper" : "");
    };

    return (
        <div>
            <Asidebar isActivated={isActivated} />
            <div id="wrapper" className={fullwidthwrapper}>
                <Header onclick={handleToggle} />
                <div id="page_wrapper" className="py-3">
                    <div className="card p-3 border-light-subtle">
                        <div>
                            <label htmlFor="" className="h5 fw-bold text-black">
                                Question and Answer Demo
                            </label>
                        </div>
                        <div>
                            <label htmlFor="" className="text-secondary">
                                Empowering users with immediate responses and insights. Transforming questions into valuable learning moments.
                            </label>
                        </div>
                        <hr />
                        <div className="common_form p-3">
                            <div className="row row-gap-4">

                                <div className="col-lg-12">
                                    <label htmlFor="retailers" className="text-black fw-500">Q1. Please select which of the following retailers you currently work with:</label>
                                </div>
                                <div className="col-lg-2 ms-4">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="option1" value="Option 1" />
                                        <label className="form-check-label  text-black fw-500" htmlFor="option1">Option 1</label>
                                    </div>
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input" id="option2" value="Option 2" />
                                        <label className="form-check-label text-black fw-500" htmlFor="option2">Option 2</label>
                                    </div>
                                </div>


                                <div className="col-lg-12">
                                    <label htmlFor="retailersText" className="text-black fw-500">Q2. Please specify which retailers you currently work with:</label>
                                </div>
                                <div className="col-lg-2 ms-4">
                                    <input type="text" className="form-control text-black fw-500" id="retailersText" />
                                </div>


                                <div className="col-lg-12">
                                    <label htmlFor="interviewAgreement" className="text-black fw-500">Q3. Do you agree to participate in an interview?</label>
                                </div>
                                <div className="col-lg-2 ms-4">
                                    <select name="interviewAgreement" className="form-select " id="interviewAgreement">
                                        <option value="">Yes, I agree</option>
                                        <option value="">No, I don't</option>
                                    </select>
                                </div>


                                <div className="col-lg-12">
                                    <label htmlFor="radioInterview" className="text-black fw-500">Q4. Do you agree to participate in an interview?</label>
                                </div>
                                <div className="col-lg-2 ms-4">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" />
                                        <label className="form-check-label text-black fw-500" htmlFor="flexRadioDefault1">
                                            Yes
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" />
                                        <label className="form-check-label text-black fw-500" htmlFor="flexRadioDefault2">
                                            No
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <button type="submit" className="btn btn-success">
                                    Submit <i className="bi bi-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DemoQuestions;
